// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"367":"9dbff2e13711323a","552":"999b493abc116a1c","696":"8a1fa8958147e50e","888":"2e57a1c2e837adb2"}[chunkId] + ".css";
};